export default __webpack_public_path__ + "static/media/privacy-policy-title-bm.c8b181af.webp";